export interface RowData {
  id: number;
  name: string;
  codeBookItemCode?: string;
  price: number | null;
  vat?: number;
  vatCode?: string;
  rate?: string;
  quantity: number | null;
  unit: string;
  currency: string;
  index: number;
}

export const initialData: RowData = {
  id: 1,
  name: '',
  codeBookItemCode: '',
  price: 0,
  vat: 0,
  vatCode: undefined,
  rate: '',
  quantity: 0,
  unit: '',
  currency: '',
  index: 0,
};
